import { Card, CardBody, Col } from "reactstrap";
import Swal from "sweetalert2";
import { Button } from "reactstrap";
import { DangerAlertTitle, DangerMode, Primary } from "../../../constants";
import { DangerAlertSubTitle } from "../../../data/bonusUi/SweetAlert";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";

// This component displays a button that triggers a SweetAlert2 error alert when clicked.
const DangerAlert = () => {
  const handleAlert = () => {
    Swal.fire({
      title: "it's danger",
      text: "Something went wrong!",
      icon: "error",
      confirmButtonColor: Primary,
    });
  };
  return (
    <Col xxl="3" lg="4" sm="6" xs="12">
      <Card>
        <CommonCardHeader title={DangerAlertTitle} span={DangerAlertSubTitle} />
        <CardBody className="btn-showcase">
          <Button color="danger" onClick={handleAlert}>
            {DangerMode}
          </Button>
        </CardBody>
      </Card>
    </Col>
  );
};
export default DangerAlert;
